import React from 'react';
import Header from '../../components/layout/Header';
import HeroSection from './components/HeroSection';
import IntroVideo from './components/IntroVideo';
import AboutSection from './components/AboutSection';
import WhyChooseUs from './components/WhyChooseUs';
import FAQSection from './components/FAQSection';
import Footer from '../../components/layout/Footer';
import NotificationBanner from '../../components/ui/NotificationBanner';
import ExperienceSection from './components/ExperienceSection';
import ComparisonSection from './components/ComparisonSection';
import ProfessionalSection from './components/ProfessionalSection';
import { Helmet } from 'react-helmet-async';
// import DiscoverSection from '../../components/DiscoverSection';
// import StudentProjects from '../../components/StudentProjects';
// import Testimonials from '../../components/Testimonials';
// import ProgramsOverview from '../../components/ProgramsOverview';
// import StatisticsSection from '../../components/StatisticsSection';

const Home = () => (
    <>
        <Helmet>
            <title>Home - Nexgen Learning - AI-Driven Education</title>
            <meta name="description" content="Home page of Nexgen Learning - AI-Driven Education" />
        </Helmet>
        <Header />
        <NotificationBanner />
        <HeroSection />
        <IntroVideo />
        <AboutSection />
        <WhyChooseUs />
        <ExperienceSection />
        <ComparisonSection />
        <ProfessionalSection />
        {/* <DiscoverSection />
        <ProgramsOverview />
        <StatisticsSection />
        <StudentProjects />
        <Testimonials /> */}
        <FAQSection />
        <Footer />
    </>
);

export default Home;